/**
 * Extrai identidade Discord a partir da sessão Supabase (provider Discord).
 * @param {import('@supabase/supabase-js').User | null | undefined} user
 * @param {import('./playerProfile').PlayerProfile | null | undefined} [profile]
 */
export function extractDiscordIdentity(user, profile) {
    const m = user?.user_metadata || {};
    const discordUserId =
        profile?.discord_user_id ||
        m.provider_id ||
        m.sub ||
        m.custom_claims?.sub ||
        null;

    const username =
        profile?.username ||
        m.preferred_username ||
        m.name ||
        m.user_name ||
        null;

    const globalName =
        profile?.display_name ||
        m.full_name ||
        m.custom_claims?.global_name ||
        m.global_name ||
        username ||
        null;

    const discriminator = m.discriminator != null ? String(m.discriminator) : null;
    const avatarUrl = profile?.avatar_url || m.avatar_url || null;

    let discordTag = username ? `@${username}` : "Discord";
    if (discriminator && discriminator !== "0") {
        discordTag = `${username}#${discriminator}`;
    } else if (globalName && username && globalName !== username) {
        discordTag = `${globalName} (@${username})`;
    } else if (globalName) {
        discordTag = globalName;
    }

    return {
        discordUserId,
        discordUsername: username,
        discordGlobalName: globalName,
        discordTag,
        discordAvatarUrl: avatarUrl,
    };
}
